import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem, fonts, metrics } from '../../__styling'

const { neutral, white, utility } = tokens.thenightly.colors.palette
const { sm, sm2l, md, m2l, lg } = metrics.thenightly.margins

interface StyledTNInputProps {
    isFilled?: boolean
    hasError?: boolean
    marginBottom?: number
    hasIcon?: boolean
}

export const StyledTNInput = styled('div')<StyledTNInputProps>(
    ({ isFilled, hasError, marginBottom = lg, hasIcon }) => ({
        fontFamily: fonts.thenightly.sansSerif,
        marginBottom: calcRem(marginBottom),
        position: 'relative',

        // Styling for the actual input
        input: {
            padding: isFilled ? calcRem(m2l, md, sm) : calcRem(sm, md),
            width: hasIcon ? '90%' : '100%',
            height: '100%',
            fontSize: calcRem(16),
            fontWeight: 400,
            background: 'transparent',
            color: hasError ? utility.error.default : neutral[100],
            borderRadius: '8px',
            border: 'transparent',
            outline: 'none',

            '&:focus': {
                padding: calcRem(m2l, md, sm),
                border: 'transparent',
                outline: 'none',

                '&+label': {
                    fontSize: calcRem(sm2l),
                    top: calcRem(sm),
                    transform: 'translateY(0)',
                    color: hasError
                        ? utility.error.default
                        : isFilled
                        ? neutral[100]
                        : neutral[70],
                },
            },

            [breakpoint('xxs')]: {
                width: hasIcon ? '92%' : '100%',
            },
            [breakpoint('sm')]: {
                width: hasIcon ? '93%' : '100%',
            },
            [breakpoint('md')]: {
                width: hasIcon ? '94%' : '100%',
            },
            [breakpoint('lg')]: {
                width: hasIcon ? '95%' : '100%',
            },
        },

        // Styling for the label for the input
        label: {
            position: 'absolute',
            fontSize: isFilled ? calcRem(sm2l) : calcRem(md),
            left: calcRem(md),
            top: isFilled ? calcRem(sm) : '50%',
            transform: isFilled ? 'translateY(0)' : 'translateY(-50%)',
            transition: 'all 0.2s',
            color: hasError
                ? utility.error.default
                : isFilled
                ? neutral[100]
                : neutral[70],
        },

        // Styling for the end icon
        svg: {
            position: 'absolute',
            right: calcRem(md),
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
        },
    }),
)

export const StyledInnerTNInput = styled('div')<StyledTNInputProps>(
    ({ isFilled, hasError }) => ({
        width: '100%',
        border: `1px solid ${
            hasError
                ? utility.error.default
                : isFilled
                ? neutral[70]
                : neutral[20]
        }`,
        borderRadius: '8px',
        height: calcRem(56),
        fontSize: calcRem(16),
        fontWeight: 400,
        background: isFilled ? white : neutral[10],
        color: hasError ? utility.error.default : neutral[100],

        '&:focus-within': {
            background: white,
            outline: '5px auto -webkit-focus-ring-color',
        },
    }),
)
